import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Chip.module.css';

/**
 * Faz tonlari (offer/decide/payment/passive) sunucudaki countdownStatus
 * degerleriyle ayni adlari tasir — kart kodunda esleme tablosu gerekmesin diye.
 */
export type ChipTone =
  | 'neutral'
  | 'primary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'buy'
  | 'sell'
  | 'offer'
  | 'decide'
  | 'payment'
  | 'passive';

export type ChipProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: ChipTone;
  size?: 'sm' | 'md';
  icon?: ReactNode;
};

export function Chip({ tone = 'neutral', size = 'md', icon, className, children, ...rest }: ChipProps) {
  const classes = [styles.chip, styles[tone], styles[size], className].filter(Boolean).join(' ');
  return (
    <span className={classes} {...rest}>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      {children}
    </span>
  );
}
